import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-panel"
// Placed on body so both the navbar button and the panel are in scope.
export default class extends Controller {
  static targets = ["content", "input"]

  open() {
    this.contentTarget.classList.remove("hidden")
    if (this.hasInputTarget) {
      this.inputTarget.focus()
    }
  }

  close() {
    this.contentTarget.classList.add("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Escape" && !this.contentTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
